import { render, staticRenderFns } from "./ResultsSummary.vue?vue&type=template&id=71f0ad7e&scoped=true&"
import script from "./ResultsSummary.vue?vue&type=script&lang=js&"
export * from "./ResultsSummary.vue?vue&type=script&lang=js&"
import style0 from "./ResultsSummary.vue?vue&type=style&index=0&id=71f0ad7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f0ad7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VRow})
